import { handleResponse, handleError } from "./apiUtils";
import { GOOGLE_API_KEY } from "./config";
import { GDIR_ACTIVE } from "./config";
import { UTMConvert } from "./utm";
import { simplifyPath } from "./douglaspeucker"; import * as apiConfig from "./config";
const appOrigin = `${apiConfig.API_URL}`;
const baseUrl = "https://maps.googleapis.com/maps/api/"; 

export async function getDirections(start, finish, mode) {

    if (directionRequestWithinCoverage(start, finish)) {
        //console.log('Graphhopper directions');

        return getJgrDirections(start, finish, mode); 
    }

    //console.log('Google directions');
    if (GDIR_ACTIVE) {
        var request = {
            origin: `${start.lat},${start.lng}`,
            destination: `${finish.lat},${finish.lng}`,
            mode: "BICYCLING"
        }

        return await getGoogleDirections(request).then((directions) => {
            //console.log('RESULTS!! ' + directions.status);
            var points = [];
            var path = directions.routes[0].overview_path;
            path.map(point => {
                points.push(standardisePoint({ lat: point.lat(), lng: point.lng() }));
            })

            points = simplifyPath(points, 0.00003)
            return points;
        }) 
    }

    return [start, finish];

}

export function getJgrDirections(start, finish, mode){
    var url = `https://directions.justgoride.net/route?point=${start.lat},${start.lng}&point=${finish.lat},${finish.lng}&vehicle=${mode}&points_encoded=false`;

    return new Promise(function (resolve, reject) {

        return fetch(url, { method: "GET", headers: { "content-type": "application/json" } })
            .then(response => {
                response.json().then(results => {
                    var points = [];

                    results.paths[0].points.coordinates.map(point => {
                        points.push(standardisePoint({ lat: point[1], lng: point[0] }));
                    })

                    points = simplifyPath(points, 0.00003)
                    resolve(points);

                }).catch(error => {
                    reject('Directions request failed due to ' + error);
                }) 
            })
            .catch(error => {
                reject('Directions request failed due to ' + error);
            });
    })
}

export function directionRequestWithinCoverage(start, finish) {
    /*UK & Ireland Coverage (Split in two to avoid french overlap).*/
    var mainUkBounds = {
        ne: { lat: 60, lng: 1.4 },
        sw: { lat: 49.9, lng: -10.7 }
    }

    console.log(start)

    if (start.lat >= mainUkBounds.sw.lat && start.lng >= mainUkBounds.sw.lng && start.lat <= mainUkBounds.ne.lat && start.lng <= mainUkBounds.ne.lng
        && finish.lat >= mainUkBounds.sw.lat && finish.lng >= mainUkBounds.sw.lng && finish.lat <= mainUkBounds.ne.lat && finish.lng <= mainUkBounds.ne.lng) {
        return true; 
    }

    var eastUkBounds = {
        ne: { lat: 60, lng: 1.95 },
        sw: { lat: 51.1, lng: 1.4 }
    }

    if (start.lat >= eastUkBounds.sw.lat && start.lng >= eastUkBounds.sw.lng && start.lat <= eastUkBounds.ne.lat && start.lng <= eastUkBounds.ne.lng
        && finish.lat >= eastUkBounds.sw.lat && finish.lng >= eastUkBounds.sw.lng && finish.lat <= eastUkBounds.ne.lat && finish.lng <= eastUkBounds.ne.lng) {
        return true;
    }

    //Add future coverage boundaries and tests below...

    return false; 
}

function getGoogleDirectionsViaApi(request) {
    var url = `${baseUrl}directions/json?origin=${request.origin}&destination=${request.destination}&mode=${request.mode}&key=${GOOGLE_API_KEY}`;
    console.log('Dong Directons!!')
    return fetch(url, { method: "POST", mode: "no-cors" })
        .then(handleResponse)
        .catch(handleError);
}

function getGoogleDirections(request) {
    return new Promise(function (resolve, reject) {
        var GoogleMapsLoader = require('google-maps');
        GoogleMapsLoader.KEY = GOOGLE_API_KEY;

        GoogleMapsLoader.load(function (google) {

            var directionsService = new google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: request.origin,
                    destination: request.destination,
                    travelMode: 'BICYCLING'
                },
                function (response, status) {
                    if (status === 'OK') {
                        resolve(response);
                    } else {
                        directionsService.route(
                            {
                                origin: request.origin,
                                destination: request.destination,
                                travelMode: 'DRIVING'
                            },
                            function (response, status) {
                                if (status === 'OK') {
                                    resolve(response);
                                } else {
                                    reject('Directions request failed due to ' + status);
                                }
                            });
                    }
                });
        });
    })
}

export function getElevation(points) {
    return getJgrElevation(points);
    //return await getGoogleElevtion(points).then((results) => {
    //    return results;
    //})
}

function getJgrElevation(points) {
    return new Promise(function (resolve, reject) {
    const url = "https://sxo1o7uhu9.execute-api.eu-west-2.amazonaws.com/Prod/elevation";
        var body = []
        points.map(point => {
            body.push([point.lat, point.lng]);
        });

        return fetch(url, { method: "POST", body: JSON.stringify(body), headers: { "content-type": "text/plain" } })
            .then(resp => {
                resp.json().then(results => {
                    results.map(result => {
                        var resultlocation = standardisePoint({ lat: result.location.lat, lng: result.location.lng });
                        points.map(point => {
                            if (point.lat == resultlocation.lat && point.lng == resultlocation.lng) {
                                point.ele = result.elevation;
                            }
                        });
                    })
                    resolve(points);
                }).catch(error => {
                    reject(error)
                }) 
            })
            .catch(error => {
                reject(error)
            });
    });
}

function getGoogleElevtion(points) {

    return new Promise(function (resolve, reject) {
        var GoogleMapsLoader = require('google-maps');
        GoogleMapsLoader.KEY = GOOGLE_API_KEY;

        GoogleMapsLoader.load(function (google) {
            var elevator = new google.maps.ElevationService();
            var locations = [];

            points.map(point => {
                locations.push(new google.maps.LatLng(point.lat, point.lng));
            });

            var positionalRequest = {
                'locations': locations
            };
            elevator.getElevationForLocations(positionalRequest, function (results, status) {
                if (status == google.maps.ElevationStatus.OK) {
                    results.map(result => {
                        var resultlocation = standardisePoint({ lat: result.location.lat(), lng: result.location.lng() });
                        points.map(point => {
                            if (point.lat == resultlocation.lat && point.lng == resultlocation.lng) {
                                point.ele = result.elevation;
                            }
                        });

                    })
                }
                resolve(points);
            });
        });
    });
}

//round up to point to ensure map variations are ruled out!

export function standardisePoint(point) {
    return { lat: roundNumber(point.lat, 5), lng: roundNumber(point.lng, 5) };
};

function roundNumber(num, dec) {
    var result = Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
    return result;
}

export function getDistanceBetweenPoints(p1, p2) {
    var earthRadius = 6371;
    var dLat = getRadians(p2.lat - p1.lat);
    var dLon = getRadians(p2.lng - p1.lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(getRadians(p1.lat)) * Math.cos(getRadians(p2.lat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (earthRadius * c) * 1000; //from km into m
};

function getRadians(x) {
    var pi = 3.14159265358979;
    return x * pi / 180;
};

//decode google encoded polyline

function decodePolyline(str, precision) {
    var index = 0,
        lat = 0,
        lng = 0,
        coordinates = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);

    while (index < str.length) {
        byte = null;
        shift = 0;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        shift = result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        lat += latitude_change;
        lng += longitude_change;

        coordinates.push({ lat: (lat / factor), lng: (lng / factor) });
    }

    return coordinates;
};

export function getRouteClickedInsertionIndex(point, pointArray) {
    //var pointArray = this.getActiveSection().points;
    point = standardisePoint(point);
    var index = -1;
    var routeClicked = false;
    for (var i = 0; i < pointArray.length; i++) {
        //calc if bearing matches..
        if (i + 1 < pointArray.length && !routeClicked) {
            var clickedPosition = UTMConvert(point.lng, point.lat);
            var currentPostion = UTMConvert(pointArray[i].lng, pointArray[i].lat);
            var nextPostion = UTMConvert(pointArray[i + 1].lng, pointArray[i + 1].lat);

            var bearingFromCurrentToClicked = (Math.atan2(clickedPosition.X - currentPostion.X, clickedPosition.Y - currentPostion.Y) * 180 / Math.PI);
            if (bearingFromCurrentToClicked < 0) bearingFromCurrentToClicked = bearingFromCurrentToClicked + 360;
            var bearingFromCurrentToNext = (Math.atan2(nextPostion.X - currentPostion.X, nextPostion.Y - currentPostion.Y) * 180 / Math.PI);
            if (bearingFromCurrentToNext < 0) bearingFromCurrentToNext = bearingFromCurrentToNext + 360;

            if (bearingsWithinTolerence(Math.round(bearingFromCurrentToClicked), Math.round(bearingFromCurrentToNext), 5)) {
                if (bearingFromCurrentToClicked >= 0 && bearingFromCurrentToClicked < 95 || (bearingFromCurrentToClicked >= 355 && bearingFromCurrentToClicked < 360)) {
                    if ((point.lng >= pointArray[i].lng && point.lng <= pointArray[i + 1].lng) && (point.lat >= pointArray[i].lat && point.lat <= pointArray[i + 1].lat)) {
                        index = i + 1;
                        routeClicked = true;
                    } else if ((bearingFromCurrentToClicked <= 360 && bearingFromCurrentToClicked >= 355) || (bearingFromCurrentToClicked <= 5 && bearingFromCurrentToClicked >= 0)) {
                        if (point.lat >= pointArray[i].lat && point.lat <= pointArray[i + 1].lat) {
                            index = i + 1;
                            routeClicked = true;
                        }
                    }
                }
                if (bearingFromCurrentToClicked >= 85 && bearingFromCurrentToClicked < 185) {
                    if ((point.lng >= pointArray[i].lng && point.lng <= pointArray[i + 1].lng) && (point.lat <= pointArray[i].lat && point.lat >= pointArray[i + 1].lat)) {
                        index = i + 1;
                        routeClicked = true;
                    } else if (bearingFromCurrentToClicked <= 95 && bearingFromCurrentToClicked >= 85) {
                        if (point.lng >= pointArray[i].lng && point.lng <= pointArray[i + 1].lng) {
                            index = i + 1;
                            routeClicked = true;
                        }
                    }
                }
                if (bearingFromCurrentToClicked >= 175 && bearingFromCurrentToClicked < 275) {
                    if ((point.lng <= pointArray[i].lng && point.lng >= pointArray[i + 1].lng) && (point.lat <= pointArray[i].lat && point.lat >= pointArray[i + 1].lat)) {
                        index = i + 1;
                        routeClicked = true;
                    } else if (bearingFromCurrentToClicked <= 185 && bearingFromCurrentToClicked >= 175) {
                        if (point.lat <= pointArray[i].lat && point.lat >= pointArray[i + 1].lat) {
                            index = i + 1;
                            routeClicked = true;
                        }
                    }
                }
                if (bearingFromCurrentToClicked >= 265 || (bearingFromCurrentToClicked > -5 && bearingFromCurrentToClicked <= 5)) {
                    if ((point.lng <= pointArray[i].lng && point.lng >= pointArray[i + 1].lng) && (point.lat >= pointArray[i].lat && point.lat <= pointArray[i + 1].lat)) {
                        index = i + 1;
                        routeClicked = true;
                    } else if (bearingFromCurrentToClicked <= 275 && bearingFromCurrentToClicked >= 265) {
                        if (point.lng <= pointArray[i].lng && point.lng >= pointArray[i + 1].lng) {
                            index = i + 1;
                            routeClicked = true;
                        }
                    }
                }
            }
        }
    }
    return index;
};

function bearingsWithinTolerence(bearing1, bearing2, tolerance) {
    var result = false;
    if (bearing1 == bearing2) {
        result = true;
    }
    else {
        for (var t = 1; t <= tolerance; t++) {
            if (bearing1 + t == bearing2) {
                result = true;
            }
            else if (bearing2 + t == bearing1) {
                result = true;
            }
        }
    }
    return result;
}








// WEBPACK FOOTER //
// ./src/api/routeUtilitiesApi.js